import useQuilttSessionToken from 'services/quiltt/queries/useQuilttSessionToken';

/** The longer-history connector the backend picked for this member; `undefined` means the default applies. */
export default function useStatementHistoryConnectorId(): string | undefined {
    const { data: sessionToken } = useQuilttSessionToken();

    return sessionToken?.statementHistoryConnectorId ?? undefined;
}
